// extracted by mini-css-extract-plugin
module.exports = {"marginSmall":"1rem","fontDefault":"1.6rem","textColorDark":"#3d3d3d","logo":"BookingSuccess_logo__Dmw0N","header":"BookingSuccess_header__3vImd"};